/**
 * Truncate a string to the specified length and append an ellipsis (...) if truncated.
 * @param str - The string to truncate.
 * @param maxLength - The maximum length of the string.
 * @returns The truncated string with ellipsis if needed.
 */
export const truncateString = (str: string, maxLength: number): string => {
  if (str.length <= maxLength) {
    return str;
  }

  return `${str.slice(0, maxLength)}...`;
};

/**
 * Capitalize the first letter of each word, lowercasing the rest.
 * Capitalizes after spaces, hyphens, and apostrophes.
 */
export const toTitleCase = (value: string): string => {
  let shouldCapitalize = true;
  let result = '';

  for (let i = 0; i < value.length; i++) {
    const char = value[i];
    const isLetter = /[a-zA-Z]/.test(char);

    if (isLetter) {
      result += shouldCapitalize ? char.toUpperCase() : char.toLowerCase();
      shouldCapitalize = false;
      continue;
    }

    result += char;
    if (char === ' ' || char === '-' || char === "'") {
      shouldCapitalize = true;
    }
  }

  return result;
};
